/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import CSSModules from 'react-css-modules';
import { routerActions } from 'react-router-redux';
import { Panel, Table } from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import RichLabel from 'loracoms/RichLabel';
import TablePager from 'loracoms/TablePager';
import { getBill, getCdrs } from 'loraapi/Billing';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles/main.scss';

const propTypes = {
  intl: intlShape.isRequired,
  location: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
};

class BillDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      more: false,
      mark: '',
      status: 'idle',
    };
    this.intlMsg = new IntlMsg(props.intl, 'billing');
    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
  }

  componentDidMount() {
    this.loadBill();
    this.loadCDRs();
  }

  intlMsg(id) {
    return this.props.intl.formatMessage({
      id: `billing.billdetail.${id}`,
      defaultMessage: `billing.billdetail.${id}`,
    });
  }

  loadBill() {
    const billid = this.props.location.query.id;
    if (billid) {
      getBill(billid).then((resp) => {
        this.setState({ bill: resp.body });
      }).catch(() => {});
    }
  }

  loadCDRs(a = {}) {
    const args = _.extend({
      mark: this.state.mark,
      pageSize: 20,
    }, a);
    const billid = this.props.location.query.id;

    if (billid) {
      this.setState({ status: 'loading' });

      const locale = this.props.intl.locale === 'zh' ? 'zh-CN' : 'en';
      moment.locale(locale);
      getCdrs(billid, args).then((resp) => {
        const cdrs = resp.body.list.map((c) => {
          let status = null;
          let duration = null;
          if (_.isNil(c.dtime)) {
            status = 'inuse';
            duration = moment() - moment(c.ctime);
          } else {
            status = 'deleted';
            duration = moment(c.dtime) - moment(c.ctime);
          }
          const ctime = moment(c.ctime).format('YY-MM-DD HH:mm:ss'); // eslint-disable-line
          const dtime = _.isNil(c.dtime) ? // eslint-disable-line
          (
            <span styleName="empty-val">
              {
                this.props.intl.formatMessage({
                  id: 'lora.emptyval',
                  defaultMessage: 'lora.emptyval',
                })
              }
            </span>
          ) : moment(c.dtime).format('YY-MM-DD HH:mm:ss');

          return { ...c, status, duration, ctime, dtime };
        });
        this.setState({
          cdrs,
          mark: resp.body.mark,
          more: resp.body.more,
          status: 'success',
        });
      }).catch(() => {
        this.setState({ status: 'failure' });
      });
    }
  }

  handleNext(mark) {
    this.loadCDRs({ mark });
  }

  handlePrev(mark) {
    this.loadCDRs({ mark });
  }

  renderBillInfo() {
    const { bill } = this.state;

    if (bill) {
      return (
        <div styleName="bill-info">
          <h5>
            { bill.period } 账单详情
          </h5>
          <ul className="list-inline">
            <li>
              <span styleName="sub">
                { this.intlMsg.msg('billdetail.billid.lbl') }
                { bill.id }
              </span>
            </li>
            <li>
              <span styleName="sub">
                { this.intlMsg.msg('billdetail.billtime.lbl') }
                { moment(bill.createdAt).format('YY-MM-DD HH:mm') }
              </span>
            </li>
          </ul>

          { this.intlMsg.msg('billdetail.billinfo.desc1') }
          <span styleName="val">{ bill.charge }</span>
          { this.intlMsg.msg('billdetail.billinfo.desc2') }
          <span styleName="val">{ bill.vol }</span>
          { this.intlMsg.msg('billdetail.billinfo.desc3') }
        </div>
      );
    }
    return null;
  }

  renderToolbar() {
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.billing'),
      onClick: () => this.props.pushState('/billing'),
    }, {
      content: this.intlMsg.msg('breadcrumb.billlogs'),
      onClick: () => this.props.pushState('/billing/billlogs'),
    }, {
      content: this.intlMsg.msg('breadcrumb.billdetail'),
      active: true,
    }];

    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderCDRsTable() {
    const { cdrs } = this.state;

    if (_.isNil(cdrs)) {
      return (
        <div styleName="table-loading">
          <i className="fa fa-spinner fa-spin fa-3x" />
        </div>
      );
    }

    const rows = cdrs.map(c => (
      <tr key={c.rid}>
        <td>{c.rid}</td>
        <td>
          <RichLabel
            content={c.status}
            translateMap={{
              inuse: this.intlMsg.msg('billdetail.status.inuse'),
              deleted: this.intlMsg.msg('billdetail.status.deleted'),
            }}
          />
        </td>
        <td>{c.duration }</td>
        <td>{c.ctime }</td>
        <td>{c.dtime }</td>
      </tr>
    ));

    return (
      <div styleName="detail-table-wrapper">
        <div styleName="detail-table">
          <Table
            className="aisz-table-light"
            bordered
            striped
            hover
            responsive
          >
            <thead>
              <tr>
                <th>{ this.intlMsg.msg('billdetail.table.header.rid') }</th>
                <th>{ this.intlMsg.msg('billdetail.table.header.status') }</th>
                <th>{ this.intlMsg.msg('billdetail.table.header.uptime') }</th>
                <th>{ this.intlMsg.msg('billdetail.table.header.ctime') }</th>
                <th>{ this.intlMsg.msg('billdetail.table.header.dtime') }</th>
              </tr>
            </thead>
            <tbody>
              { rows }
            </tbody>
          </Table>
        </div>
        <TablePager
          pullRight
          status={this.state.status}
          mark={this.state.mark}
          more={this.state.more}
          onNext={this.handleNext}
          onPrev={this.handlePrev}
        />
      </div>
    );
  }

  render() {
    return (
      <div styleName="wrapper">
        <div>
          { this.renderToolbar() }
        </div>
        <div>
          <Panel bsStyle="aisz-white">
            { this.renderBillInfo() }
            { this.renderCDRsTable() }
          </Panel>
        </div>
      </div>
    );
  }
}

BillDetail.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null,
  mapDispatchToProps,
  )(injectIntl(
    CSSModules(BillDetail, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Billing/BillDetail/index.jsx